import { getBorderBase, getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import Typography from 'components/Typography';
import { COMPONENTS_NAMES } from 'theme/constants';

const prefix = ['components', COMPONENTS_NAMES.FILTERS, 'appliedFilterPreview'];

export const AppliedFiltersList = styled.div<{ $isVisible: boolean }>`
  height: 0;
  display: flex;
  align-items: center;
  column-gap: 14px;
  transition: all 0.3s ease;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      height: 65px;
      margin-bottom: -14px;
      overflow-x: scroll;
      margin-top: 12px;
    `};
`;

export const Container = styled.div<{ $isDisabled?: boolean }>`
  height: 52px;
  display: flex;
  column-gap: 10px;
  border-style: solid;
  ${getBorderBase(prefix)};

  cursor: pointer;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.5;
    `};
`;

export const FilterName = styled(Typography)`
  display: block;
  white-space: nowrap;
  color: ${getPrefixedVar(prefix, 'name')};
`;

export const Value = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  color: ${getPrefixedVar(prefix, 'filterValue')};
`;

export const FilterValue = styled(Typography)`
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Operation = styled.div`
  flex: 0 0 16px;
  height: 16px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const FilterContent = styled.div`
  padding: 6px 0 6px 12px;
`;

export const ActionsContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  border-left-style: solid;
  ${getBorderBase([...prefix, 'actions'])};
`;

export const ButtonWrapper = styled.div`
  flex: 0 0 50%;
  padding: 3px;
  display: flex;
  place-content: center center;
`;

export const PowerButtonWrapper = styled(ButtonWrapper)`
  border-bottom-style: solid;
  ${getBorderBase([...prefix, 'actions'])};
`;
